import { useCallback, useState } from 'react';
import _ from 'lodash';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import Input from 'components/Input';
import Button from 'components/Button';
import SuccessBox from 'components/SuccessBox';
import { sendForgotPasswordEmail } from 'entities/Auth/sdk';

const ResendResetLinkForm = ({ email }: { email: string }) => {
  const [resetLinkSent, setResetLinkSent] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [formErrors, setErrors] = useState({ errors: {}, message: '' });

  const resendLink = useCallback(() => {
    setIsSubmitting(true);
    sendForgotPasswordEmail({ email })
      .then(() => {
        setResetLinkSent(true);
      })
      .catch((err) => {
        err.response?.text()?.then((data: string) => setErrors(JSON.parse(data)));
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }, [email]);

  return (
    <>
      {resetLinkSent && (
        <div className={'flex flex-col gap-[24px]'}>
          <SuccessBox text='Reset password link sent'>
            <div className='flex flex-col gap-[8px]'>
              <div className='flex gap-[8px]'>
                <InformationCircleIcon className='size-[20px] text-primary' />
                <div className='flex-1 font-[MuseoSansCyrl] text-[14px]'>
                  We sent a link for resetting your password in your email. Please check your inbox and follow the link
                  to choose your new password.
                </div>
              </div>
              <div className='flex gap-[8px]'>
                <InformationCircleIcon className='size-[20px] text-primary' />
                <div className='flex-1 font-[MuseoSansCyrl] text-[14px] max-w-[400px]'>
                  If you haven’t received a link, please use the button below to resend the email.
                </div>
              </div>
            </div>
          </SuccessBox>
          <Button onClick={resendLink} styles={'self-center w-full md:w-fit font-semibold'} disabled={isSubmitting}>
            Resend Reset Link
          </Button>
        </div>
      )}
      {!resetLinkSent && (
        <>
          <h1 className='bold text-grey800 font-[DKLiquidEmbrace] text-3xl pb-[24px] text-center md:text-left'>
            Your link has expired, please resend a new 'Set password’ link.
          </h1>
          {!_.isEmpty(formErrors.errors) && (
            <div className='text-danger pb-[10px]'> {_.map(formErrors?.errors, (value: string) => value)}</div>
          )}
          {_.isEmpty(formErrors.errors) && formErrors.message !== '' && (
            <div className='text-danger pb-[10px]'>{formErrors.message}</div>
          )}
          <div className={'flex flex-col gap-[24px]'}>
            <Input label='Email address' value={email} disabled={true} />
            <Button onClick={resendLink} styles={'w-full md:w-fit font-semibold'} disabled={isSubmitting}>
              Resend link
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default ResendResetLinkForm;
